import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from 'material-ui/styles';
import { ChildAccountLetterOrderAuthorityValue, ChildAccountTimelineAuthorityValue, ChildAccountAuthorityValue, ChildAccountDownloadHistoryAuthorityValue } from '../../../constants/ComponentTypes';

import DialogModal from '../../common/DialogModal';
import Button from '../../Parts/Button';
import { FormControl } from 'material-ui/Form';
import MenuItem from 'material-ui/Menu/MenuItem';
import Select from 'material-ui/Select';
import Checkbox from 'material-ui/Checkbox';
import Typography from 'material-ui/Typography'
import { isEnabledSendLetter, isEnabledExportExecutiveList } from '../../../utils/planUtils';

const styles = () => ({
  paper: {
    maxHeight: 'unset',
    background: "#F4F6F9",
    width: '600px',
  },

  checkboxContainer: {
    width: '100%',
    textAlign: 'left',
    marginTop: '30px',
  },

  contentContainer: {
    margin: 0,
    padding: 0,
  },

  container: {
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '25px',
  },

  content: {
    marginTop: '8px',
    padding: '12px 20px 20px',
    boxSizing: 'border-box',
    border: '1px solid #D8DBDF',
    background: '#FFFFFF',
    width: '100%',
    cursor: 'pointer',
  },

  disabledButton: {
    backgroundColor: '#D8DBDF',
    color: '#D8DBDF',
    borderRadius: 'unset',
  },

  text: {
    paddingLeft: "5px",
    fontSize: "14px",
  },

  entry: {
    width: '100%',
    marginTop: '8px',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    transition: 'transform 1s cubic-bezier(0.77, 0, 0.175, 1), -webkit-transform 0.3s cubic-bezier(0.77, 0, 0.175, 1)',
  },

  select: {
    textAlign: 'left',
  }
});

class EditAuthorityDialog extends React.Component {
  state = {
    value: 0,
    error: {},
    message: '',
    order_letter: false,
    edit: false,
    edit_tag: false,
    download_letter_ordered_list: false,
    download_list: false,
  }

  componentWillMount() {
    const { childUser, authorityType } = this.props;
    let setValue;
    let order_letter = false;
    let edit = false
    let edit_tag = false
    let download_letter_ordered_list = false
    let download_list = false
    if (childUser && childUser.user_role) {
      if (authorityType === "letter-order") {
        setValue = !childUser.user_role[authorityType]['read'] ? ChildAccountLetterOrderAuthorityValue.UNACCESSIBLE.value : ChildAccountLetterOrderAuthorityValue.READ.value;
      } else if (authorityType === "download-history") {
        // 権限の保存データがない子アカウントはアクセス不可として扱う
        const downloadHistoryRole = childUser.user_role[authorityType];
        setValue = downloadHistoryRole && downloadHistoryRole['read'] ? ChildAccountDownloadHistoryAuthorityValue.READ.value : ChildAccountDownloadHistoryAuthorityValue.UNACCESSIBLE.value;
      } else if (authorityType === "timeline") {
        setValue = childUser.user_role[authorityType]['edit'] ? ChildAccountTimelineAuthorityValue.EDIT.value :
          childUser.user_role[authorityType]['read'] ? ChildAccountTimelineAuthorityValue.READ.value :
            ChildAccountTimelineAuthorityValue.UNACCESSIBLE.value;
      } else if (authorityType === "house-list") {
        setValue = !!childUser.user_role[authorityType]['edit'] ||
          !!childUser.user_role[authorityType]['edit-tag'] ||
          !!childUser.user_role[authorityType]['order-letter'] ||
          !!childUser.user_role[authorityType]['download-list'] ?
          ChildAccountAuthorityValue.EDIT.value :
          childUser.user_role[authorityType]['read'] ?
            ChildAccountAuthorityValue.READ.value :
            ChildAccountAuthorityValue.UNACCESSIBLE.value;
        order_letter = childUser.user_role[authorityType]['order-letter'];
        edit = childUser.user_role[authorityType]['edit'];
        edit_tag = childUser.user_role[authorityType]['edit-tag'];
        download_list = childUser.user_role[authorityType]['download-list'];
      } else if (authorityType === "executive-list") {
        setValue = !!childUser.user_role[authorityType]['edit-tag'] ||
          !!childUser.user_role[authorityType]['order-letter'] ||
          !!childUser.user_role[authorityType]['download-list'] ||
          !!childUser.user_role[authorityType]['download-letter-ordered-list'] ?
          ChildAccountAuthorityValue.EDIT.value :
          childUser.user_role[authorityType]['read'] ?
            ChildAccountAuthorityValue.READ.value :
            ChildAccountAuthorityValue.UNACCESSIBLE.value;
        order_letter = childUser.user_role[authorityType]['order-letter'];
        edit_tag = childUser.user_role[authorityType]['edit-tag'];
        download_letter_ordered_list = childUser.user_role[authorityType]['download-letter-ordered-list'];
        download_list = childUser.user_role[authorityType]['download-list'];
      }
    }
    this.setState({
      value: setValue,
      order_letter: order_letter,
      edit: edit,
      edit_tag: edit_tag,
      download_letter_ordered_list: download_letter_ordered_list,
      download_list: download_list,
    });
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.isSaving && !nextProps.isSaving) {
      nextProps.toggleDialog();
    }

    if (!this.props.error && nextProps.error) {
      if (nextProps.error && nextProps.error.data && nextProps.error.data.message) {
        this.setState({
          message: nextProps.error.data.message,
        })
      }
    }
  }

  handleClose = () => {
    this.props.toggleDialog();
  };

  handleCheck = (property) => () => {
    this.setState({
      [property]: !this.state[property],
    })
  }

  handleSave = () => {
    const { childUser, authorityType } = this.props;
    let date = {
      authorityType: authorityType,
      authority: this.state.value,
    };
    if (authorityType === 'house-list') {
      date = {
        ...date,
        order_letter: this.state.order_letter,
        edit: this.state.edit,
        edit_tag: this.state.edit_tag,
        download_list: this.state.download_list,
      };
    } else if (authorityType === 'executive-list') {
      date = {
        ...date,
        order_letter: this.state.order_letter,
        edit_tag: this.state.edit_tag,
        download_list: this.state.download_list,
        download_letter_ordered_list: this.state.download_letter_ordered_list,
      };
    }
    this.props.save(childUser.id, date);
  }

  handleChange = property => e => {
    let value;
    value = e.target.value;
    this.setState({
      [property]: value,
    })
  }

  renderCheckboxContent = (info, i) => {
    const { classes } = this.props;
    return (
      <div className={classes.entry} onClick={this.handleCheck(info.key)} key={i}>
        <Checkbox
          color="primary"
          checked={this.state.value === ChildAccountAuthorityValue.EDIT.value ? this.state[info.key] : false}
          onChange={this.handleCheck(info.key)}
          classes={{ disabled: classes.disabledButton }}
          style={{
            width: "17px",
            height: "17px",
          }}
          disabled={this.state.value !== ChildAccountAuthorityValue.EDIT.value}
        />
        <Typography
          variant="subheading"
          className={classes.text}
          style={{ color: this.state.value !== ChildAccountAuthorityValue.EDIT.value ? "#D8DBDF" : "#181819" }}
        >
          {info.title}
        </Typography>
      </div>
    )
  }

  render() {
    const { classes, toggleDialog, isOpen, title, user, isSaving } = this.props;
    const houseListCheckboxInfo = [
      { title: 'レター送付', key: 'order_letter' },
      { title: 'アドレスの追加 / 編集', key: 'edit' },
      { title: 'リストの追加 / 編集', key: 'edit_tag' },
      { title: 'キーマンリストDL', key: 'download_list' },
    ]

    let executiveListCheckboxInfo = [
      { title: 'リストの追加 / 編集', key: 'edit_tag' },
    ];

    if (isEnabledExportExecutiveList(user)) {
      executiveListCheckboxInfo.push(
        { title: 'キーマンリストDL', key: 'download_list' }
      );
    }

    if (isEnabledSendLetter(user)) {
      executiveListCheckboxInfo.push(
        { title: 'レター送付', key: 'order_letter' },
        { title: '注文済みキーマンDL', key: 'download_letter_ordered_list' }
      );
    }

    return (
      <DialogModal
        open={isOpen}
        onClose={toggleDialog}
        aria-labelledby="pop-up-window"
        maxWidth={false}
        title={(title ? `${title}の` : '') + '権限を編集'}
        classes={{
          paper: classes.paper,
          contentContainer: classes.contentContainer,
        }}
      >
        <div className={classes.container}>
          <FormControl fullWidth>
            <Select
              value={this.state.value}
              onChange={this.handleChange('value')}
              classes={{ select: classes.select }}
              disableUnderline={true}
              notched="true"
            >
              {Object.values(
                title && title === 'タイムライン' ? ChildAccountTimelineAuthorityValue : title && title === '注文履歴' ? ChildAccountLetterOrderAuthorityValue : title && title === 'ダウンロード履歴' ? ChildAccountDownloadHistoryAuthorityValue : ChildAccountAuthorityValue
              ).map(item => (
                <MenuItem key={item.value} value={item.value}>{item.text}</MenuItem>
              ))}
            </Select>
          </FormControl>
          {title && (title === '自社リスト' || title === 'キーマンデータベース') && (
            <div className={classes.checkboxContainer}>
              <Typography
                variant="subheading"
                className={classes.text}
                style={{ fontWeight: "bold", fontSize: "13px" }}
              >
                権限の詳細を設定できます。
              </Typography>
              <div className={classes.content}>
                {title === 'キーマンデータベース' && (
                  executiveListCheckboxInfo.map((info, i) => this.renderCheckboxContent(info, i))
                )}
                {title === '自社リスト' && (
                  houseListCheckboxInfo.map((info, i) => this.renderCheckboxContent(info, i))
                )}
              </div>
            </div>
          )}
          <Button
            text="変更内容を保存"
            handleClickButton={this.handleSave}
            style={{ marginTop: '30px', width: '100%' }}
            loading={isSaving}
          />
        </div>
      </DialogModal>
    );
  }
}

EditAuthorityDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  toggleDialog: PropTypes.func.isRequired,
  title: PropTypes.string,
  save: PropTypes.func.isRequired,
  isSaving: PropTypes.bool,
  childUser: PropTypes.object,
  user: PropTypes.object,
  authorityType: PropTypes.string,
  error: PropTypes.object,
};

export default withStyles(styles)(EditAuthorityDialog);



// WEBPACK FOOTER //
// ./src/components/AccountSetting/dialogs/EditAuthorityDialog.jsx